<template>
  <div class="line-item">
    <div class="heading ml-2" style="display: flex" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')">
      <!-- <v-btn class="mx-0" icon @click.prevent="$store.myActions.UI_TOGGLE_FLEET_MAP_VISIBILITY({fleId:fleet.FLE_ID,uiid:detailUiid})" :title="$t(mapVisibility[mission.misId]?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{mapVisibility[mission.misId]?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn> -->
      <v-icon class="!text-black">{{ fleetIco }}</v-icon>
      <fleet-state :fleet="fleet" />
      <v-btn
        class="missionbtn mx-0 pr-2"
        :class="{ testMission: fleet.isTestFleet }"
        flat
        :title="
          $t(
            detailVisibility[fleet.FLE_ID]
              ? 'Pilot.MissionDrawer.HideMoreMissionInfosTooltip'
              : 'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip'
          )
        "
      >
        {{ fleet.FLE_LIBELLE }}
      </v-btn>
      <v-btn class="mx-0" small icon flat @click.stop.prevent="deleteFleet()"
        ><v-progress-circular class="ml-2" :size="20" v-if="deleting" indeterminate color="white"></v-progress-circular
        ><v-icon v-else>mdi-delete</v-icon></v-btn
      >
      <v-btn
        class="mx-0"
        small
        v-if="accesPilotReachDetail.visible"
        :disabled="!accesPilotReachDetail.enable"
        icon
        flat
        :to="accesPilotReachDetail.enable ? { name: 'FleetDetail', params: { fleetid: fleet.FLE_ID } } : null"
        :title="$t('Pilot.MissionDrawer.ReachMissionPageTooltip')"
        ><v-icon>mdi-forward</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script setup lang="ts">
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import store from '@/store'
import { i18n } from '@/locale/vueI18n'
import FleetState from './FleetState.vue'
import { computed, getCurrentInstance, ref } from 'vue'
import { VuetifyConfirmObject } from 'vuetify-confirm/types'

const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm!

const props = defineProps({
  fleet: {
    type: AloDbFleet,
    required: true
  }
})

const deleting = ref(false)

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const accesPilotReachDetail = computed(() => {
  return props.fleet.security[SecurityItemsKeys.PILOT_REACH_DETAIL]
})

const detailVisibility = computed(() => {
  return {}
})

async function deleteFleet() {
  if (!deleting.value) {
    const answer = await $confirm(i18n.t('Fleet.DeleteDialogMessage', { name: props.fleet.FLE_LIBELLE }).toString(), {
      title: i18n.t('Admin.Warning')
    } as VuetifyConfirmObject)
    if (answer) {
      //@ts-ignore
      deleting.value = true
      try {
        await store.myActions.ADMINFLEET_DELETE_REQUEST(props.fleet)
      } finally {
        deleting.value = false
      }
    }
  }
}
</script>
